import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { keys, get } from 'lodash'
import TrendFacilitationHeader from '../../components/TrendFacilitationHeader'
import SideCountriesSelector from '../../components/SideCountriesSelector'
import SideCountryTrends from '../../components/SideCountryTrends'
import Modal from '../../components/Modal'
import MultiStarChart from '../../components/MultiStarChart'
import { getCsvFile } from '../../utils/csvdownload'
import {
  loadCountryFacilitation,
  unloadCountryFacilitation,
  loadTfaArticles,
  loadTfaProvisions,
  setSelectedCountry,
  setComparisonCountry,
  setSelectedCountryData,
  setComparisonCountryData
} from '../../state/actions'
import Select from 'react-select'
import './index.css'

const CountryFacilitationPoliciesLegend = ({ close }) => {
  return (
    <Modal close={close}>
      <img src="/legend/02.png" alt="Legend" />
    </Modal>
  )
}

const INDICATORS_LIST = [
  'inf_availability',
  'inv_community',
  'adv_rulings',
  'appeal_proc',
  'fees_charges',
  'form_docs',
  'form_auto',
  'form_proc',
  'int_cooperation',
  'ext_cooperation',
  'gov_impartiality',
]

const TFA_ARTICLES_LIST = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
]
const TFA_ARTICLES_DESCRIPTIONS = {
  '1': 'Publication and availability of information',
  '2':
    'Opportunity to comment, information before entry into force and consultations',
  '3': 'Advance rulings',
  '4': 'Procedures for appeal or review',
  '5':
    'Other measures to enhance impartiality, non-discrimination and transparency',
  '6':
    'Disciplines on fees and charges imposed on or in connection with importation and exportation and penalties',
  '7': 'Release and clearance of goods',
  '8': 'Border agency cooperation',
  '9': 'Movement of goods intended for import under customs control',
  '10': 'Formalities connected with importation, exportation and transit',
  '11': 'Freedom of transit',
  '12': 'Customs cooperation',
}

class CountryFacilitationPolicies extends React.PureComponent {
  state = {
    latestDataByIndicator: require('../../data/latest_by_indicator.json'),
    legend: false,
    focus: null,
  }

  componentWillMount() {
    this.props.loadCountryFacilitation()
    this.props.loadTfaArticles()
    this.props.loadTfaProvisions()
  }

  componentWillUnmount() {
    this.props.unloadCountryFacilitation()
    this.props.setSelectedCountry(null)
    this.props.setSelectedCountryData(null)
    this.props.setComparisonCountry(null)
    this.props.setComparisonCountryData(null)
  }

  toggleLegend = e => {
    this.setState({ legend: !this.state.legend })
  }

  handleFocusChange = item => {
    this.setState({ focus: item ? item.value : null })
  }

  downloadCsv = e => {
    const { countries } = this.props
    getCsvFile(
      `country-facilitation.csv`,
      keys(countries).sort(),
      INDICATORS_LIST,
      TFA_ARTICLES_LIST,
    )
  }

  render() {
    const { indicators, selectedCountry, tfaArticles, tfaMeta } = this.props
    const { focus } = this.state

    //indicators list for SideCountryTrends
    let indicatorsList = INDICATORS_LIST.filter(code => indicators[code])
      .map(code => indicators[code])
      .filter(i => i.domain)

    let tfaArticlesList = TFA_ARTICLES_LIST

    const focusIndicatorOptions = indicatorsList
      .map(i => {
        return { label: i.shortTitle, value: i.globalId }
      })
      .concat(
        tfaArticlesList.map(i => ({ label: `TFA Article ${i}`, value: i })),
      )

    const activeByFocused = {
      inf_availability: { tfa: ['1'], ind: ['inf_availability'] },
      inv_community: { tfa: ['2'], ind: ['inv_community'] },
      adv_rulings: { tfa: ['3'], ind: ['adv_rulings'] },
      appeal_proc: { tfa: ['4'], ind: ['appeal_proc'] },
      fees_charges: { tfa: ['6'], ind: ['fees_charges'] },
      form_docs: { tfa: ['10'], ind: ['form_docs'] },
      form_auto: { tfa: ['7'], ind: ['form_auto'] },
      form_proc: { tfa: ['7', '10'], ind: ['form_proc'] },
      int_cooperation: { tfa: ['8'], ind: ['int_cooperation'] },
      ext_cooperation: { tfa: ['8'], ind: ['ext_cooperation'] },
      gov_impartiality: { tfa: [], ind: ['gov_impartiality'] },

      '1': { tfa: ['1'], ind: ['inf_availability'] },
      '2': { tfa: ['2'], ind: ['inv_community'] },
      '3': { tfa: ['3'], ind: ['adv_rulings'] },
      '4': { tfa: ['4'], ind: ['appeal_proc'] },
      '5': { tfa: ['5'], ind: [] },

      '6': { tfa: ['6'], ind: ['fees_charges'] },
      '7': { tfa: ['7'], ind: ['form_auto', 'form_proc'] },
      '8': { tfa: ['8'], ind: ['int_cooperation', 'int_cooperation'] },
      '9': { tfa: ['8'], ind: [] },
      '10': { tfa: ['10'], ind: ['form_docs', 'form_proc'] },
      '11': { tfa: ['11'], ind: [] },
      '12': { tfa: ['12'], ind: [] },
    }

    const focusedOptions = get(activeByFocused, `[${focus}]`, null)
    if (focus) {
      const validIndicators = get(activeByFocused, `[${focus}].ind`, [])
      indicatorsList = indicatorsList.filter(
        i => validIndicators.indexOf(i.globalId) !== -1,
      )
      tfaArticlesList = get(activeByFocused, `[${focus}].tfa`, [])
    }

    return (
      <div>
        {/* <TopBar/> */}
        <TrendFacilitationHeader showSortMode={'sort'} hasShowSort={false} />
        <div className="h-container cf">
          {this.state.legend && (
            <CountryFacilitationPoliciesLegend close={this.toggleLegend} />
          )}
          <div className="fl-l w-40-l ph4">
            <h2 className="text-blue text-medium">
              Trade facilitation policies and TFA notifications
            </h2>

            <div className="cf">
              <div className="w-third fl tc">
                <span
                  onClick={this.toggleLegend}
                  className="explore-link link-lightblue underline pointer"
                  to="/topics/ETIB03"
                >
                  LEGEND
                </span>
              </div>
              <div className="w-third fl tr">
                <a
                  className="explore-link link-lightblue underline pointer"
                  onClick={this.downloadCsv}
                >
                  DOWNLOAD
                </a>
              </div>
            </div>

            {selectedCountry === null && (
              <div className="leftside-text text-gray">
                <p>
                  Under the World Trade Organization’s (WTO) Trade Facilitation
                  Agreement (TFA) which entered into force in 2017, developing
                  countries can ask for assistance from the international
                  community to implement specific provisions of the agreement.{' '}
                </p>
                <p>
                  They are expected to send to the WTO a notification list
                  categorising the TFA provisions under one of the following
                  categories:{' '}
                </p>
                <p>
                  ▪ Category A: Provisions that the Member will implement by the
                  time the Agreement enters into force (or in the case of a
                  least-developed country Member within one year after entry
                  into force)
                </p>
                <p>
                  ▪ Category B: Category B: Provisions that the Member will
                  implement after a transitional period following the entry into
                  force of the Agreement{' '}
                </p>
                <p>
                  ▪ Category C: Provisions that the Member will implement on a
                  date after a transitional period following the entry into
                  force of the Agreement and requiring the acquisition of
                  assistance and support for capacity building.
                </p>
                <p>
                  The figure provides an overview of the policies currently in
                  place in the countries as measured by the OECD Trade
                  Facilitation Indicators (blue petals) and of their
                  notifications grouped by the 12 articles of the TFA (red
                  petals). Longer rays represent, respectively, better trade
                  facilitation policies and more comprehensive commitments with
                  respect to the TFA articles.
                </p>
                {/* <p>
                  By selecting a country on the navigation
                  header, all visualsation will have the
                  Country Selected.
                </p> */}
              </div>
            )}
            {selectedCountry !== null && (
              <div>
                {/* graph type selector */}
                <div className="mt3 text-blue pt3">
                  <div className="blue-text">
                    <small>FOCUS ON TOPIC</small>
                  </div>
                  <Select
                    className="FocusSelect"
                    name="select_focus"
                    value={this.state.focus}
                    clearable={true}
                    options={focusIndicatorOptions}
                    onChange={this.handleFocusChange}
                  />
                </div>

                <SideCountriesSelector />
                <SideCountryTrends
                  indicatorsList={indicatorsList}
                  tfaArticles={tfaArticles}
                  tfaArticlesList={tfaArticlesList}
                  tfaArticlesDescriptions={TFA_ARTICLES_DESCRIPTIONS}
                  tfaMeta={tfaMeta}
                />
              </div>
            )}
          </div>
          <div className="fl-l w-60-l">
            <div className="cf pa2">
              <Link
                className="link-orange no-underline hero-top-link fl pa2 mb3"
                to="/third-pillar"
              >
                <small>&lt; BORDER TRANSPARENCY AND EFFICIENCY</small>
              </Link>
              <Link
                className="link-orange no-underline hero-top-link fr pa2 pr4 mb3"
                to="/enabling-trade-environment"
              >
                <small>THE ENABLING TRADE ENVIRONMENT &gt;</small>
              </Link>
            </div>

            <div>
              <MultiStarChart
                focusedOptions={focusedOptions}
                latestDataByIndicator={this.state.latestDataByIndicator}
                tfaArticles={tfaArticles}
              />
            </div>

            <div className="cf ph2">
              <Link
                className="link-orange no-underline hero-top-link fl pa2 mb3"
                to="/third-pillar"
              >
                <small>&lt; BORDER TRANSPARENCY AND EFFICIENCY</small>
              </Link>
              <Link
                className="link-orange no-underline hero-top-link fr pa2 pr4 mb3"
                to="/enabling-trade-environment"
              >
                <small>SEVEN PILLARS &gt;</small>
              </Link>
            </div>

            {/* <div>
              <Link className="link-orange no-underline hero-bottom-link fl" to="/third-pillar">
                <small>CLICK TO EXPLORE THE TRADE FACILITATION</small>
              </Link>
              <Link className="link-orange no-underline hero-bottom-link fr" to="/seven-pillars">
                <small>CLICK TO EXPLORE THE SEVEN PILLARS</small>
              </Link>
              <span className="cf"></span>
            </div> */}
          </div>
        </div>

        {/* footer */}
        {/* <Footer/> */}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  countries: state.countries,
  indicators: state.indicators,
  selectedCountry: state.selectedCountry,
  selectedCountryData: state.selectedCountryData,
  comparisonCountry: state.comparisonCountry,
  comparisonCountryData: state.comparisonCountryData,
  countryFacilitationPolicies: state.countryFacilitationPolicies.data,
  tfaArticles: state.tfaArticles.data,
  tfaMeta: state.tfaMeta,
  tfaProvisions: state.tfaProvisions.data,
})

const mapDispatchToProps = {
  loadCountryFacilitation,
  unloadCountryFacilitation,
  loadTfaArticles,
  loadTfaProvisions,
  setSelectedCountry,
  setComparisonCountry,
  setSelectedCountryData,
  setComparisonCountryData,
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CountryFacilitationPolicies)



// WEBPACK FOOTER //
// ./src/pages/CountryFacilitationPolicies/index.js